import * as React from "react";
import { cx } from "../internal/cx.js";

export interface ConsentRowProps
  extends Omit<React.LabelHTMLAttributes<HTMLLabelElement>, "children"> {
  /** Checkbox (or checkbox-like Radix primitive) rendered before the consent copy — parent owns `checked` / `onCheckedChange`. */
  checkbox: React.ReactElement;
  children: React.ReactNode;
}

/**
 * Checkbox + muted legal/supporting copy aligned to registration-flow
 * patterns. Wraps the consumer-supplied checkbox and label copy in a single
 * `<label>` so clicking the copy toggles the checkbox.
 */
export const ConsentRow = React.forwardRef<HTMLLabelElement, ConsentRowProps>(function ConsentRow(
  { checkbox, children, className, ...props },
  ref,
) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: the `checkbox` prop is the consumer-supplied form control; biome can't statically inspect runtime children to verify it.
    <label ref={ref} className={cx("cw-v2-consent-row", className)} {...props}>
      {checkbox}
      <span className="cw-v2-consent-row__label">{children}</span>
    </label>
  );
});
ConsentRow.displayName = "ConsentRow";
